module.exports = __webpack_public_path__ + "img/bank-filters.a4306f54.svg";